export const visTimelineItems = (state = null, action) => {
  switch (action.type) {
    case "FETCH_VIS_TIMELINE_SUCCESS":
      return action.items;
    default:
      return state;
  }
};
